import { render, staticRenderFns } from "./AppVersionNotice.vue?vue&type=template&id=6ae277de&scoped=true"
import script from "./AppVersionNotice.vue?vue&type=script&lang=js"
export * from "./AppVersionNotice.vue?vue&type=script&lang=js"
import style0 from "./AppVersionNotice.vue?vue&type=style&index=0&id=6ae277de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae277de",
  null
  
)

export default component.exports